import { Table } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormatDate } from 'src/components/table/Date';

import { Panel } from '../../components/Panel';
import { Enrollment, LessonStatus } from './Enrollment';

interface State {}
interface Props {
  enrollment: Enrollment;
  loading: any;
  userId: number;
}
export class LessonDetail extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }
  render() {
    const { enrollment, userId, loading } = this.props;
    return (
      <>
        <Panel bordered={false}>
          <Table
            dataSource={(enrollment && enrollment.lessonProgresses) || []}
            pagination={false}
            rowKey={progress => `${progress.serialId}`}
            loading={loading}
          >
            <Table.Column title="课时" dataIndex="lesson.name" key="lessonName" />
            <Table.Column
              title="解锁日期"
              dataIndex="unlockAt"
              key="unlockAt"
              render={unlockAt => <FormatDate mode="date" date={unlockAt} />}
            />
            <Table.Column
              title="学习状态"
              dataIndex="status"
              key="status"
              render={status => {
                switch (status) {
                  case LessonStatus.COMING:
                    return '未开课';
                  case LessonStatus.LOCKED:
                    return '未解锁';
                  case LessonStatus.UNLOCKED:
                    return '未完课';
                  case LessonStatus.HIGHLIGHT:
                    return '未完课';
                  case LessonStatus.PLAYED:
                    return '已完成';
                  default:
                    return '未开课';
                }
              }}
            />
            <Table.Column
              title="学习次数"
              dataIndex="evaluations"
              key="evaluations"
              render={evaluations => {
                return evaluations.length;
              }}
            />
            <Table.Column
              title="操作"
              key="action"
              render={row => (
                <>
                  <Link to={`/user/${userId}/enrollment/${enrollment.id}/lesson/${row.serialId}`}>详情</Link>
                  <Link
                    to={`/user/${userId}/enrollment/${enrollment.id}/serial/${row.serialId}/attendances/${row.lesson.id}`}
                    style={{ marginLeft: 8 }}
                  >
                    查看attendance
                  </Link>
                </>
              )}
            />
          </Table>
        </Panel>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/enrollment/LessonDetail.tsx